import type { IconData } from '@stacksjs/iconify-core'

export const sortNumericUp: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m102.627 130.313l51.882-51.881V496h32V78.432l51.883 51.882l22.627-22.627l-90.51-90.51L80 107.687zM435.313 200h-40V56h-32v32h-32v32h32v80h-40v32h112zm-76.799 232h-19.2v32h19.2a76.886 76.886 0 0 0 76.8-76.8v-51.6a55.66 55.66 0 0 0-55.6-55.6h-4.4a55.663 55.663 0 0 0-55.6 55.6v4.4a55.663 55.663 0 0 0 55.6 55.6h4.4a55.3 55.3 0 0 0 23.475-5.215A44.85 44.85 0 0 1 358.514 432m21.2-68.4h-4.4a23.627 23.627 0 0 1-23.6-23.6v-4.4a23.627 23.627 0 0 1 23.6-23.6h4.4a23.626 23.626 0 0 1 23.6 23.6v4.4a23.626 23.626 0 0 1-23.601 23.6Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default sortNumericUp
